/**
 * Generates a unique event ID for GTM/GA4 tracking
 * Format: timestamp_random
 * Example: 1705689600000_a1b2c3
 */
export const generateEventId = (): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 8); // 6 char random string
  return `${timestamp}_${random}`;
};
